'use client';

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
interface Suspensao<T> {
  cobrancaId: string;
  leitura: readonly T[];
}

/**
 * Suspende o "Pagar" da cobrança que a regeração acabou de cancelar, até uma leitura NOVA do
 * financeiro chegar.
 *
 * O POST cancela a cobrança e o servidor emite outra, mas a tela só fica sabendo na leitura
 * seguinte: até lá, a linha continua oferecendo o link cancelado. Leitura que FALHA não solta
 * a suspensão, porque `useFinanceiroProcesso` preserva as cobranças anteriores e o link na tela
 * continua sendo o da cobrança cancelada. Só uma leitura bem-sucedida troca o array.
 *
 * A suspensão guarda a leitura que estava na tela quando o POST respondeu, e não a do clique:
 * uma leitura que chegasse durante o POST já teria sido tirada antes do cancelamento.
 *
 * `cobrancas` tem de ser o array CRU do estado de `useFinanceiroProcesso`, que só muda numa
 * leitura bem-sucedida. Um array derivado a cada render (`montarCobrancasCliente`) soltaria a
 * trava no render seguinte, e a correção dependeria da memoização do React Compiler. E é uma
 * instância por tela (a de `useCustasProcesso`): o banner e a aba Financeiro ficam na tela ao
 * mesmo tempo, e a regeração feita num tem de travar o "Pagar" do outro.
 */
export function useLinkCanceladoAteReleitura(cobrancas) {
  const $ = _c(7);
  const [suspensao, setSuspensao] = useState(null);
  const leituraNaTela = useRef(cobrancas);
  let t0;
  let t1;
  if ($[0] !== cobrancas) {
    t0 = () => {
      leituraNaTela.current = cobrancas;
    };
    t1 = [cobrancas];
    $[0] = cobrancas;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cobrancaId => setSuspensao({
      cobrancaId,
      leitura: leituraNaTela.current
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const suspenderLink = t2;
  let t3;
  if ($[4] !== cobrancas || $[5] !== suspensao) {
    const linkSuspenso = cobrancaId_0 => suspensao !== null && suspensao.cobrancaId === cobrancaId_0 && suspensao.leitura === cobrancas;
    t3 = {
      linkSuspenso,
      suspenderLink
    };
    $[4] = cobrancas;
    $[5] = suspensao;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}